import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { MaterialModule } from './material.module';
import { DrawerComponent } from '../components/drawer/drawer.component';
import { LoginComponent } from '../components/login/login.component';
import { MenuComponent } from '../components/menu/menu.component';
import { MenuItemComponent } from '../components/menu/menu-item.component';
import { NotificationComponent } from '../components/notification/notification.component';
import { ToolbarComponent } from '../components/toolbar/toolbar.component';
import { MenuPipe } from '../pipes/menu.pipe';
import { SidenavComponent } from '../components/sidenav/sidenav.component';
import { LogoutComponent } from '../components/logout/logout.component';
import { OptionComponent } from '../components/option/option.component';
import { SharedModule } from './shared.module';
import { OfflineComponent } from '../components/offline/offline.component';

@NgModule({
  declarations: [
    ToolbarComponent,
    OfflineComponent,
    SidenavComponent,
    DrawerComponent,
    LoginComponent,
    LogoutComponent,
    MenuComponent,
    MenuItemComponent,
    NotificationComponent,
    
    OptionComponent,
    MenuPipe,
  ],
  imports: [
    BrowserModule,
    MaterialModule,
    SharedModule,
    RouterModule,
    TranslateModule.forChild()
  ],
  exports: [
    ToolbarComponent,
    OfflineComponent,
    SidenavComponent,
    DrawerComponent,
    LoginComponent,
    LogoutComponent,
    MenuComponent,
    MenuItemComponent,
    NotificationComponent,
    OptionComponent,
    MenuPipe
  ],
})
export class MasterPageModule { }
